<template>
  <div class="mailbox">
    <div class="mailbox-list_btn">
      <el-button type="primary" @click="show = true">我要写信</el-button>
    </div>
    <div class="mailbox-list" v-if="listTotal > 0">
      <div class="mailbox-list_tab">
        <el-table
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          :data="list"
          border
          style="width: 100%"
        >
          <el-table-column prop="created_at" label="发布时间" align="center" width="180"> </el-table-column>
          <el-table-column label="发布内容" align="center">
            <template v-slot="scoped">
              <p>{{scoped.row.content}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="reply_time" label="回复时间" align="center" width="180"> </el-table-column>
          <el-table-column label="回复内容" align="center">
            <template v-slot="scoped">
              <p>{{scoped.row.reply}}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mailbox-list_page">
        <el-pagination
          :page-size="condition.limit"
          :current-page="condition.page"
          background
          layout="prev, pager, next"
          @current-change="getListFn"
          :total="listTotal">
        </el-pagination>
      </div>

    </div>
    <div class="mailbox-no" v-else-if="listTotal == 0">
      <ComponentEmpty
        title="暂无信件"
        tips
      />
    </div>


    <el-dialog
      title="我要写信"
      :visible.sync="show"
      width="500px"
      :before-close="()=>{show = false}">
        <div class="mailbox-pop">
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
          >
            <!-- 问题描述： -->
            <el-form-item prop="content">
              <el-input
                type="textarea"
                v-model="form.content"
                placeholder="请详细描述您的建议、意见及问题。有助于我们更快的发现和解决问题"
                rows="10"
                show-word-limit
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="show = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import { mailboxApi, mailboxApplyApi } from "@/api/basic";

export default {
  name: "Mailbox",
  components: {
  },
  data() {
    return {
      condition:{
        limit:10,
        page:1
      },
      list:[],
      listTotal:-1,
      show:false,
      form: {
        content: "",
      },
      rules: {
        content: [
          {
            required: true,
            message: "请输入问题描述",
            trigger: "blur",
          },
        ],
      },

    };
  },
  created() {
    this.getListFn();
  },
  methods: {

    async getListFn(pageNum){
      if(pageNum){
        this.condition.page = pageNum
        this.list = []
        this.listTotal = -1
      }
      let params = this.condition;
      const {code,result,msg} = await mailboxApi(params);
      if(code != 200)return
      this.list = [...result.list]
      this.listTotal = result.total
    },


    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.handleSubmit(this.form);
        } else {
          return false;
        }
      });
    },
    //  提交
    async handleSubmit(values) {
      const res = await mailboxApplyApi(values);
      if (res.code == 200) {
        this.show = false
        this.$message.success("提交成功");
        this.getListFn(1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mailbox{
  min-height:$sideBarH;
  margin: 20px;
  padding: 20px;
  background: $white;
  &-list{
    &_tab{
      margin-top: 20px;
    }
    &_page{
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
  &-no{
    height: calc(927px - 80px);
    display: flex;
    align-items: center;
  }
}
</style>
